import { supabaseClient } from './supabase'
import { processRequest, returnResponseError } from './request'
import { SingleNote } from 'contexts/note'
import { SupabaseClient } from '@supabase/supabase-js'

export const createNote = async (title: string) => {
  const { data: note_id, error } = await supabaseClient.rpc('create_note')
  if (error !== null) {
    console.error(error)
    return returnResponseError(error)
  }

  return processRequest(
    supabaseClient
      .from('notes')
      // @ts-ignore
      .update({
        note_title: title,
      })
      .eq('id', note_id)
  ).then((response) => {
    if (response.ok) {
      return {
        ...response,
        data: note_id,
      }
    }

    return response
  })
}

export const saveNoteText = (
  note_id: string,
  note_text: string,
  sensitive_text: string,
  client?: SupabaseClient
) => {
  return processRequest(
    (client ?? supabaseClient).from('notes_versions').insert({
      note_id: note_id,
      note_text: note_text,
      sensitive_text: sensitive_text,
    })
  )
}

export const getNoteText = (note_id: string, client?: SupabaseClient) => {
  return processRequest(
    (client ?? supabaseClient)
      .from('notes_versions')
      .select('created_at, note_text, sensitive_text')
      .eq('note_id', note_id)
      .order('created_at', {
        ascending: false,
      })
      .limit(1)
  )
}

export const getAllNotes = () => {
  return processRequest(supabaseClient.rpc('list_notes'))
}

export const getNote = (note_id: string) => {
  return processRequest(
    supabaseClient.from('notes').select('*').eq('id', note_id)
  )
}

export const updateNoteData = (note_id: string, data: Partial<SingleNote>) => {
  return processRequest(
    supabaseClient
      .from('notes')
      .update(
        // @ts-ignore
        data
      )
      .eq('id', note_id)
  )
}

export const deleteNoteData = (note_id: string, client?: SupabaseClient) => {
  const supa = client ?? supabaseClient
  // it deletes using cascade; recipients and note_versions referring to this note_id will also be deleted.
  // add more tables to cascade (query saved in supabase), if needed.
  return processRequest(supa.from('notes').delete().eq('id', note_id))
}
